/**
 * @generated SignedSource<<f48693d80eaaa35f737aed690ff7d0e5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileSettingsForm_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NotificationSettingsForm_recipient"
    }
  ],
  "type": "User",
  "abstractKey": null
};

node.hash = "557e9cf7bc39240bb10f0286602cfa14";

module.exports = node;
